<template>
  <div v-if="deviceStore.type == 'desktop'" class="from-div">
    <div class="from-h-div">
      <CarouselCard :BackImageList="BackImageList" :intervalSpeed="intervalSpeed"></CarouselCard>
    </div>
    <div class="from-p-div">
      <div class="from-div">
        <div class="mo-div">
          <CardShowcaseButton v-model:subsidiaryColor="CardShowcaseFrom.a.subsidiaryColor"
            v-model:mainColor="CardShowcaseFrom.a.mainColor" v-model:svgValue="CardShowcaseFrom.a.svg"
            :title="CardShowcaseFrom.a.title" :anniuValue="CardShowcaseFrom.a.anniuValue"
            :content="CardShowcaseFrom.a.content" :deviceStoreType="'desktop'" @button-click="handleAClick">
          </CardShowcaseButton>
          <CardShowcaseButton v-model:subsidiaryColor="CardShowcaseFrom.b.subsidiaryColor"
            v-model:mainColor="CardShowcaseFrom.b.mainColor" v-model:svgValue="CardShowcaseFrom.b.svg"
            :title="CardShowcaseFrom.b.title" :anniuValue="CardShowcaseFrom.b.anniuValue"
            :content="CardShowcaseFrom.b.content" :deviceStoreType="'desktop'" @button-click="GoToLogin">
          </CardShowcaseButton>
        </div>
        <div class="title-div-mo">
          <img src="../assets/iconmao_a.png" class="title-h-mao">
          <h1 class="title-h-w">阿波罗的猫</h1>
        </div>
        <div class="login-from">
          <div class="back-icon" @click="backJieMian">
            <img src="../assets/back.png">
            <h1 class="back-font">返回</h1>
          </div>
          <h2 class="big-title-h">欢迎登录</h2>
          <el-form :model="form" label-width="70px">
            <el-form-item label="账号" class="login-label">
              <el-input v-model="form.username" class="zhmm" placeholder="请输入您的账号"></el-input>
            </el-form-item>
            <el-form-item label="密码" class="login-label">
              <el-input type="password" v-model="form.password" class="zhmm" placeholder="请输入您的密码"></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="login-label">
              <el-input v-model="form.yzm" class="yzm" placeholder="请输入图形验证码"></el-input>
              <img :src="captchaImage" alt="验证码" @click="refreshCaptcha" class="captcha-image" />
            </el-form-item>
          </el-form>
          <div>
            <el-button type="primary" class="custom-button primary" @click="handleLogin">登录</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="shuaitu-icon" @click="shuaitutiaozhuan"></div>
  </div>
  <div v-else-if="deviceStore.type == 'mobile'" class="from-div">
    <div class="from-h-div">
      <CarouselCard :BackImageList="BackImageList" :intervalSpeed="intervalSpeed"></CarouselCard>
    </div>
    <div class="from-p-div">
      <div class="from-div">
        <div class="mo-div">
          <CardShowcaseButton v-model:subsidiaryColor="CardShowcaseFrom.a.subsidiaryColor"
            v-model:mainColor="CardShowcaseFrom.a.mainColor" v-model:svgValue="CardShowcaseFrom.a.svg"
            :title="CardShowcaseFrom.a.title" :anniuValue="CardShowcaseFrom.a.anniuValue"
            :content="CardShowcaseFrom.a.content" :deviceStoreType="'mobile'" @button-click="handleAClick">
          </CardShowcaseButton>
          <CardShowcaseButton v-model:subsidiaryColor="CardShowcaseFrom.b.subsidiaryColor"
            v-model:mainColor="CardShowcaseFrom.b.mainColor" v-model:svgValue="CardShowcaseFrom.b.svg"
            :title="CardShowcaseFrom.b.title" :anniuValue="CardShowcaseFrom.b.anniuValue"
            :content="CardShowcaseFrom.b.content" :deviceStoreType="'mobile'" @button-click="GoToLogin">
          </CardShowcaseButton>
        </div>
        <div class="title-div-mo">
          <img src="../assets/iconmao_a.png" class="title-h-mao">
          <h1 class="title-h-mobile">阿波罗的猫</h1>
        </div>
        <div class="login-from login-from-mobile">
          <div class="back-icon" @click="backJieMian">
            <img src="../assets/back.png">
            <h1 class="back-font">返回</h1>
          </div>
          <h2 class="big-title-h">欢迎登录</h2>
          <el-form :model="form" label-width="70px">
            <el-form-item label="账号" class="login-label">
              <el-input v-model="form.username" class="zhmm" placeholder="请输入您的账号"></el-input>
            </el-form-item>
            <el-form-item label="密码" class="login-label">
              <el-input type="password" v-model="form.password" class="zhmm" placeholder="请输入您的密码"></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="login-label">
              <el-input v-model="form.yzm" class="yzm" placeholder="请输入图形验证码"></el-input>
              <img :src="captchaImage" alt="验证码" @click="refreshCaptcha" class="captcha-image" />
            </el-form-item>
          </el-form>
          <div>
            <el-button type="primary" class="custom-button primary" @click="handleLogin">登录</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="shuaitu-icon" @click="shuaitutiaozhuan"></div>
  </div>

</template>

<script>

import { useDeviceStore } from '@/stores/device.js';
import request from '@/utils/request' // 就写这一行

export default {
  name: 'LoginPage',
  setup() {
    const deviceStore = useDeviceStore();
    console.log("打印用户设备类型");
    console.log(deviceStore.type);
    return { deviceStore };
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        yzm: ''
      },
      captchaImage: '',
      captchaImageAn: '',
      CardShowcaseFrom: {
        "a": {
          "title": "参考项目后台", "content": "个人后台项目的开发", "mainColor": "rgb(190,245,191)",
          "subsidiaryColor": "rgba(255,255,255,1)", "anniuValue": "参观一下",
          "svg": `<svg t="1750737552903" class="icon" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6471" width="60" height="60"><path d="M917.747 136.223H114.583c-28.477 0-51.265 17.212-51.265 45.9v516.33c0 22.946 22.784 45.891 45.572 45.891h321.97l-8.685 91.796h-62.658c-22.783 0-39.874 28.683-39.874 51.633h381.65c5.697-17.213-11.39-51.633-34.182-51.633h-62.658l-8.676-91.796h321.97c22.784 0 45.572-22.95 45.572-45.891v-516.33c0-28.688-22.788-45.9-45.572-45.9z m-5.697 476.176H120.28V187.856h791.77v424.543zM336.738 337.017c13.42 0 26.757-5.562 36.252-15.124 9.486-9.553 15.012-22.986 15.012-36.504 0-13.523-5.526-26.955-15.012-36.513-9.49-9.554-22.828-15.12-36.252-15.12-13.423 0-26.761 5.566-36.256 15.12-9.49 9.562-15.017 22.99-15.017 36.513 0 13.518 5.526 26.95 15.017 36.504 9.49 9.563 22.828 15.124 36.256 15.124z m421.515 68.85H541.794V555.03h216.46V405.868z m0-149.166H541.794v17.213h216.46v-17.213z m0 34.421H541.794v17.212h216.46v-17.212zM490.53 405.867H274.077v17.208h216.459v-17.207z m0 34.416H274.077v17.208h216.459v-17.208z m0 28.688H274.077v17.208h216.459v-17.208z m0 34.42H274.077v17.213h216.459v-17.212z m0 34.421H274.077v17.217h216.459v-17.217z" fill="#ffffff" p-id="6472"></path></svg>`
        },
        "b": {
          "svg": `<svg t="1750751607135" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8467" width="60" height="60"><path d="M378.154667 489.514667v276.309333a32 32 0 1 0 64 0v-277.077333a372.266667 372.266667 0 0 1 183.338666 66.56A255.744 255.744 0 0 0 512 768c0 79.829333 36.522667 151.125333 93.824 198.058667C385.877333 1009.322667 42.666667 958.634667 42.666667 839.68c0-164.693333 147.2-331.008 335.488-350.165333z m233.984-246.229334c0 110.72-89.6 200.576-200.149334 200.576a200.448 200.448 0 0 1-200.234666-200.576A200.490667 200.490667 0 0 1 411.861333 42.666667a200.448 200.448 0 0 1 200.277334 200.618666z m311.893333 554.112a39.168 39.168 0 0 0 18.688 14.037334 35.925333 35.925333 0 0 1 4.608 3.072 17.28 17.28 0 0 1 5.76 8.874666c0.512 3.072 0.426667 6.784-0.384 11.136a67.328 67.328 0 0 1-10.368 25.429334 23.722667 23.722667 0 0 1-8.448 7.68 18.56 18.56 0 0 1-8.106667 2.304 22.656 22.656 0 0 1-7.68-1.536 80.256 80.256 0 0 0-9.6-2.133334 44.714667 44.714667 0 0 0-11.733333-0.341333c-3.968 0.384-7.936 1.194667-11.946667 2.474667a23.338667 23.338667 0 0 0-10.154666 6.570666 37.930667 37.930667 0 0 0-10.752 21.930667c-1.024 8.192 0.128 16.042667 3.456 23.466667 2.56 5.12 2.176 10.24-1.152 15.402666a28.629333 28.629333 0 0 1-7.296 6.357334 80.298667 80.298667 0 0 1-10.965334 5.973333c-3.968 1.792-8.106667 3.2-12.501333 4.266667a51.072 51.072 0 0 1-11.52 1.493333 9.813333 9.813333 0 0 1-6.528-2.688 14.592 14.592 0 0 1-4.266667-5.76h-0.341333a47.616 47.616 0 0 0-14.421333-20.608 35.413333 35.413333 0 0 0-23.637334-8.661333 36.352 36.352 0 0 0-23.637333 8.661333c-7.04 5.76-11.989333 12.501333-14.805333 20.224a13.141333 13.141333 0 0 1-5.76 6.741333 17.237333 17.237333 0 0 1-8.448 2.133334c-3.584 0-7.68-0.682667-12.117334-1.962667a113.066667 113.066667 0 0 1-13.44-4.821333 64.170667 64.170667 0 0 1-12.117333-6.741334 33.450667 33.450667 0 0 1-8.106667-7.68 11.776 11.776 0 0 1-2.090666-6.357333 23.381333 23.381333 0 0 1 2.901333-10.197333 38.570667 38.570667 0 0 0 3.242667-20.224 34.986667 34.986667 0 0 0-9.813334-20.949334 25.002667 25.002667 0 0 0-13.056-7.509333 53.077333 53.077333 0 0 0-14.592-1.365333 64.426667 64.426667 0 0 0-16.554666 3.072 15.658667 15.658667 0 0 1-10.752-0.768 16.896 16.896 0 0 1-7.893334-7.125334 79.061333 79.061333 0 0 1-10.922666-26.154666 32.298667 32.298667 0 0 1-0.768-11.733334c0.768-5.674667 3.328-9.258667 7.68-10.794666 7.68-3.072 14.592-8.149333 20.736-15.189334a35.157333 35.157333 0 0 0 9.258666-23.68 33.536 33.536 0 0 0-9.258666-23.466666 56.917333 56.917333 0 0 0-20.736-14.677334c-2.304-0.768-4.266667-2.602667-5.76-5.546666a19.413333 19.413333 0 0 1-2.304-9.045334c0-3.370667 0.512-7.082667 1.536-11.178666 1.024-4.096 2.346667-8.106667 4.010666-11.946667 1.706667-3.84 3.584-7.381333 5.76-10.581333a23.381333 23.381333 0 0 1 7.125334-7.125334 8.874667 8.874667 0 0 1 5.973333-1.536 34.218667 34.218667 0 0 1 6.314667 1.536c7.68 3.072 15.701333 4.053333 24.021333 2.901334a38.997333 38.997333 0 0 0 22.101333-10.965334 27.306667 27.306667 0 0 0 6.741334-11.349333 62.378667 62.378667 0 0 0 2.688-25.216 151.381333 151.381333 0 0 0-0.938667-7.68 41.642667 41.642667 0 0 1-1.365333-5.418667 8.362667 8.362667 0 0 1 0.597333-5.376 22.016 22.016 0 0 1 8.234667-9.472c3.968-2.688 8.277333-4.906667 12.885333-6.698666 4.608-1.834667 9.088-3.157333 13.44-4.053334 4.352-0.896 7.850667-1.365333 10.410667-1.365333 3.328 0 5.973333 1.109333 7.850666 3.285333a19.541333 19.541333 0 0 1 4.053334 6.741334c2.816 6.912 7.424 13.013333 13.824 18.261333 6.4 5.290667 13.952 7.893333 22.698666 7.893333 8.96 0 16.896-2.474667 23.808-7.509333a40.149333 40.149333 0 0 0 14.634667-19.029333 25.216 25.216 0 0 1 4.778667-6.357334c2.176-2.176 4.437333-3.285333 6.741333-3.285333 3.584 0 7.509333 0.512 11.733333 1.536 4.224 1.024 8.362667 2.474667 12.458667 4.266667 4.138667 1.792 7.893333 4.096 11.349333 6.912a37.077333 37.077333 0 0 1 8.277334 9.258666c1.28 2.048 1.664 4.266667 1.152 6.698667a23.552 23.552 0 0 1-1.536 5.205333 40.917333 40.917333 0 0 0-3.072 23.466667c1.28 8.234667 4.992 15.402667 11.136 21.589333a34.432 34.432 0 0 0 22.698666 10.197334c8.96 0.64 17.28-0.853333 24.96-4.437334a11.776 11.776 0 0 1 7.509334-1.536c2.944 0.256 5.418667 1.408 7.466666 3.456 3.84 3.626667 7.253333 9.045333 10.24 16.384 2.901333 7.296 4.906667 14.677333 5.930667 22.144 0.512 4.352-0.213333 7.722667-2.133333 10.197334a14.336 14.336 0 0 1-5.973334 4.778666 45.098667 45.098667 0 0 0-20.352 14.848 37.546667 37.546667 0 0 0-8.448 24.064c0 8.704 2.389333 16.341333 7.125334 22.912z m-94.848-77.098666a76.842667 76.842667 0 0 0-54.528-22.442667 74.666667 74.666667 0 0 0-29.866667 5.973333 77.354667 77.354667 0 0 0-40.789333 40.832 74.666667 74.666667 0 0 0-5.973333 29.824c0 10.581333 2.005333 20.565333 5.973333 29.866667 4.010667 9.258667 9.472 17.450667 16.426667 24.533333a75.904 75.904 0 0 0 54.186666 22.613334 75.946667 75.946667 0 0 0 54.613334-22.613334c6.912-7.082667 12.373333-15.274667 16.384-24.576a74.666667 74.666667 0 0 0 5.973333-29.824 74.666667 74.666667 0 0 0-5.973333-29.866666 77.269333 77.269333 0 0 0-16.426667-24.32z" fill="#ffffff" p-id="8468"></path></svg>`,
          "title": "网站后台", "content": "使用您的账号进入后台", "mainColor": "rgb(76,132,136)",
          "subsidiaryColor": "rgba(255,255,255,1)", "anniuValue": "登录"
        }
      },
      BackImageList: ['//www.aboluo.site/api/uploadsl/vue/01.jpg', '//www.aboluo.site/api/uploadsl/vue/02.jpg', '//www.aboluo.site/api/uploadsl/vue/03.jpg', '//www.aboluo.site/api/uploadsl/vue/04.png', '//www.aboluo.site/api/uploadsl/vue/05.jpg', '//www.aboluo.site/api/uploadsl/vue/06.jpg'],
      intervalSpeed: 20000
    };
  },
  methods: {
    async handleLogin() {
      // 模拟登录成功
      // localStorage.setItem('token', 'some-auth-token');
      // this.$router.push({ name: 'DashboardPage' });
      const { username, password, yzm } = this.form; // 假设表单字段为 account 和 password

      if (!username || !password || !yzm) {
        this.$messageX.xiaoxiti("w", "账号、密码、图片验证码不能为空！");
        return;
      }
      const user_sid = this.$socket.currentSocketId;

      if (!user_sid) {
        this.$messageX.xiaoxiti("e", "网络连接异常，请刷新重试");
        return;
      }
      try {
        const res = await request.post('/BackgroundLogin',
          {
            Accounts: username,
            PassWord: password,
            PictureVerify: yzm,
            veriftyID: this.captchaImageAn
          }, {
          headers: {
            'X-Socket-ID': user_sid
          }
        });

        // ✅ 关键：将 token 存入 localStorage 或 Vuex/Pinia
        localStorage.setItem('token', res.response.token);
        localStorage.setItem('background_user_info', JSON.stringify(res.response.user));
        this.$messageX.xiaoxiti("c", "登录成功!");
        this.$router.push({ name: 'DashboardPage' });
      } catch (err) {
        console.log('失败:', err)
        if (err.response.data.message) {
          this.$messageX.xiaoxiti("e", err.response.data.message);
        } else {
          this.initData();
          this.$messageX.xiaoxiti("e", err.message);
        }
      }
    },
    async refreshCaptcha() {
      try {
        // 自动带 Token，自动处理错误
        const res = await request.get('/HuoQuTuPianYanZhenMa', {
        })

        // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
        this.$messageX.xiaoxiti("c", "图片验证码刷新成功！");
        this.captchaImage = res.captchaImageSrc;
        this.captchaImageAn = res.veriftyID;

      } catch (err) {
        // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
        console.log('失败:', err)
        if (err.response.data.message) {
          this.$messageX.xiaoxiti("e", err.response.data.message);
        } else {
          this.initData();
          this.$messageX.xiaoxiti("e", err.message);
        }
      }
    },
    GoToLogin() {
      document.querySelector('.mo-div').classList.add('mo-div-deng');
      document.querySelector('.login-from').classList.add('login-from-deng');
      document.querySelector('.title-div-mo').classList.add('title-div');
    },
    handleAClick() {
      // console.log("参考项目后台");
      if (this.deviceStore.type == "mobile") {
        this.$messageX.xiaoxiti("w", "请在电脑端查看后台！");
      } else {
        this.$messageX.xiaoxiti("消息", "参考项目后台");
        localStorage.setItem('token', 'some-auth-token');
        this.$router.push({ name: 'VisitorPage' });
      }

    },
    backJieMian() {
      // console.log("返回默认界面");
      document.querySelector('.mo-div').classList.remove('mo-div-deng');
      document.querySelector('.login-from').classList.remove('login-from-deng');
      document.querySelector('.title-div-mo').classList.remove('title-div');
    },
    shuaitutiaozhuan() {
      this.$router.push({ name: 'ShuaituMorPPage' });
    }
  },
  mounted() {
    this.refreshCaptcha();
    var lq = document.querySelectorAll(".el-form-item__content");
    for (let item of lq) {
      item.style.flexWrap = "nowrap";
    }
    localStorage.setItem('current_address', 'LoginPage');
  }
};
</script>

<style scoped>
.shuaitu-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 50px;
  height: 50px;
  background-image: url('../assets/shuaituicon.png');
  background-size: cover;
  z-index: 12;
}

.login-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.from-h-div {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 8;
}

.from-p-div {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.back-icon {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 2%;
  left: 5%;
  cursor: pointer;
}

.back-font {
  font-size: 15px;
  font-weight: 600;
  color: #4a4949;
  font-style: normal;
  margin-left: 5px;
  cursor: pointer;
}

.mo-div {
  width: 100%;
  height: 50%;
  position: absolute;
  left: 0%;
  top: 40%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  transition: all 0.8s ease;
}

.mo-div-deng {
  top: 100%;
}

.login-from {
  width: 410px;
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 9px 8px 30px 5px rgba(0, 0, 0, 0.15);
  transform: translateY(-50%);
  position: fixed;
  right: calc(0% - 410px);
  top: 50%;
  z-index: 10;
  transition: all 0.8s ease;
}

.login-from-mobile {
  width: 370px;
  padding: 15px;
}

.login-from-deng {
  right: calc((100% - 370px) / 2);
}

.from-div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.title-h-mobile {
  top: 17%;
  right: 0%;
  font-size: 32px;
  color: white;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 10px;
  padding-left: 2vw;
}

.title-h-w {
  top: 17%;
  right: 0%;
  font-size: 32px;
  color: white;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 10px;
  padding-left: 2vh;
}

.title-div-mo {
  position: absolute;
  top: 0vh;
  left: calc((100% - 265px) / 2);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: 55vh;
  transition: all 0.8s ease;
  width: 269px;
}

.title-div {
  top: 100%;
  left: 20vw;
}

.yzm {
  width: 56%;
  height: 48px;
}

.zhmm {
  width: 100%;
  height: 48px;
}

.captcha-image {
  height: 46px;
  width: 120px;
  border: 2px solid #ddd;
  border-left: none;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
}

.login-label {
  display: flex;
  font-weight: 600;
  color: #444;
  align-items: center;
}

.big-title-h {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 25px;
}

.custom-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  background-color: #4a76da;
  color: white;
}

.title-h-mao {
  width: 6vh;
}

.primary {
  padding: 15px 25px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  transition: all 0.3s ease;
  height: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  display: flex;
  flex-direction: row;
  place-content: center;
  align-items: center;
}
</style>
